import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "MongoDB Atlas project",
  connector: "MongoDB Atlas",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]+$/;

const ATLAS_PROJECT_ID_PATTERN = /^[0-9a-f]{24}$/;

export const MongodbAtlasAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to MongoDB Atlas",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens",
    schema: {
      atlasProjectId: Element({
        label: "Atlas project ID",
        description:
          "The 24-character ID of the Atlas project, from Project Settings in Atlas",
        type: "string",
        step: "new",
        validator: async (_context: unknown, projectId: string) =>
          ATLAS_PROJECT_ID_PATTERN.test(projectId)
            ? undefined
            : "Use the 24 lowercase hexadecimal characters of the project ID",
      }),
      secretManager,
      clientId: Element({
        label: "Client ID",
        description:
          "Client ID of the Atlas service account that P0 manages MCP configurations with. It needs the Project Owner role in the project.",
        type: "string",
      }),
    },
  }),
});
